import { useContext } from 'react';

import { UserAgentContext } from '@/common/contexts/UserAgentContext/UserAgentContext';

const getDeviceCategory = (isDesktop: boolean | undefined) => (isDesktop ? 'desktop' : 'mobile');

/**
 * @deprecated useUserAgentContext instead use csses with mobile first approach. Use RWD. If you need to use this context, please contact with UX team.
 */
export const useUserAgentContext = () => {
  const currentUserAgentContext = useContext(UserAgentContext);

  if (!currentUserAgentContext) {
    throw new Error('UserAgentContext has to be used within <UserAgentContext.Provider>');
  }

  return {
    ...currentUserAgentContext,
    deviceCategory: getDeviceCategory(currentUserAgentContext?.isDesktop),
  };
};
